<template>
  <small v-if="activeEnvConfig">
    <span v-if="showVersion">{{ activeEnvConfig.version }}</span>
    <span
      class="uk-text-uppercase uk-text-danger"
      v-if="showBanner && showEnvBanner"
      >{{ showVersion ? ' ' : '' }}({{
        activeEnvConfig.environment.deployment
      }})</span
    >
  </small>
</template>

<script lang="ts">
import { Options as Component, Prop, Vue } from 'vue-property-decorator';
import { namespace, Action } from 'vuex-class';
import { Ability } from '@casl/ability';
import type { EnvConfig } from '@license-manager/types';

const envconfig = namespace('envconfig');

@Component({
  components: {},
  name: 'VersionInfo',
})
class VersionInfo extends Vue {
  @Prop({ default: true })
  showVersion: boolean;

  @Prop({ default: true })
  showBanner: boolean;

  @envconfig.Action('loadEnvConfig') loadEnvConfig: () => Promise<any>;

  @envconfig.Getter
  activeEnvConfig: EnvConfig;

  @envconfig.Getter
  showEnvBanner: boolean;

  async mounted() {
    try {
      await this.loadEnvConfig();
    } catch (error) {
      console.error('Loading environment configuration failed', error);
    }
  }
}

export default VersionInfo;
</script>

<style scoped></style>
